import { useMutation } from "@apollo/client/react";
import { useNotificationState } from "hooks/state";
import flatten from "lodash/flatten";
import values from "lodash/values";
import GqlError from "utils/GqlError";
import { DeleteShift } from "./shift.gql";

export default function useDeleteShift() {
  const { setNotification } = useNotificationState();
  const [deleteShift] = useMutation(DeleteShift, {
    onCompleted: ({ deleteShift: { name } }) => {
      setNotification({
        title: `${name} was successfully deleted.`,
        type: "success",
      });
    },
    onError: (error) => {
      GqlError.handler(error, (errors) => {
        const allErrors = flatten(values(errors)).join("\n");

        setNotification({
          message: allErrors,
          title: "Unable to delete shift",
          type: "danger",
        });
      });
    },
  });

  return (options) => deleteShift(options);
}
